import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Smartphone } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const AccountState = ({ a }) => {
  if (!a) return <span className="text-muted-foreground" data-testid="employee-app-account-none">Nessun accesso all'app</span>;
  return (
    <span data-testid="employee-app-account">
      Accesso app: <span className="font-mono">{a.email}</span>{" "}
      {!a.active ? <span className="bg-slate-200 px-1 text-[10px] uppercase">disattivato</span> : !a.activated ? <span className="bg-amber-100 px-1 text-[10px] uppercase text-amber-900">invito in attesa</span>
        : <span className="text-xs text-muted-foreground">{a.last_login_at ? `ultimo accesso ${fmtDateTime(a.last_login_at)}` : "mai entrato"}</span>}
    </span>
  );
};

export const WorkEmail = ({ emp, onChanged }) => {
  const { can } = useAuth();
  const [v, setV] = useState(emp.work_email || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setV(emp.work_email || ""); }, [emp.id, emp.work_email]);
  const dirty = (v.trim().toLowerCase() || null) !== (emp.work_email || null);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/employees/${emp.id}/work-email`, { work_email: v || null });
      toast.success(r.data.account_updated ? "Email aziendale salvata: aggiornato anche l'accesso all'app, avviso inviato al nuovo indirizzo" : "Email aziendale salvata");
      onChanged();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const createAccess = async () => {
    if (!window.confirm(`Creare l'accesso all'app per ${emp.first_name} ${emp.last_name} e inviare l'invito a ${emp.work_email}?`)) return;
    setBusy(true);
    try { await api.post(`/employees/${emp.id}/app-access`); toast.success(`Accesso creato, invito inviato a ${emp.work_email}`); onChanged(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 border-l-2 border-foreground pl-3" data-testid="employee-work-email">
      <div className="micro-label flex items-center gap-1"><Mail className="h-3 w-3" />Email aziendale · ordini, app e avvisi di lavoro</div>
      {can("hr:write") ? (
        <div className="mt-1.5 flex gap-2">
          <Input type="email" className="max-w-xs" value={v} onChange={(e) => setV(e.target.value)} placeholder="nome@azienda.it" data-testid="employee-work-email-input" />
          {dirty && <Button size="sm" onClick={save} disabled={busy} data-testid="employee-work-email-save">Salva</Button>}
        </div>
      ) : <div className="mt-1 font-mono text-sm">{emp.work_email || "—"}</div>}
      <div className="mt-2 flex flex-wrap items-center gap-3 text-sm">
        <AccountState a={emp.app_account} />
        {!emp.app_account && emp.work_email && !dirty && can("group:manage") && (
          <Button size="sm" variant="outline" onClick={createAccess} disabled={busy} data-testid="employee-create-app-access"><Smartphone className="mr-1 h-4 w-4" />Crea accesso app</Button>
        )}
      </div>
      {emp.app_account && emp.work_email && emp.app_account.email !== emp.work_email && (
        <p className="mt-1 text-xs text-amber-700" data-testid="employee-email-mismatch">L'accesso all'app usa un indirizzo diverso: salva di nuovo l'email aziendale per allinearlo.</p>
      )}
    </div>
  );
};
